import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { TinyPeopleListManager } from 'managers/discussion/people/tinyList';
import { IWCCStorageManager } from 'managers/iStorage';
import TopicParticipantsManager from 'managers/topic/participants';
import Participant from 'models/participant';
import { Person } from 'models/person';
import PersonTiny from 'models/personTiny';
import { TopicThread } from 'models/topicThread';
import './participants.html';
import './participants.scss';

export interface CommentParticipantsVMCofig {
    comment?: SubscribableOrNullableValue<TopicThread>
}

@injectable()
export default class CommentParticipantsVM {
    private topicId: Subscribable<string | undefined>
    private user: Subscribable<Person | undefined>

    label = `${labels.VisibleTo}:`

    participants: Subscribable<Array<PersonTiny | Participant>>

    isActive: Subscribable<boolean>
    isLoading: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentParticipantsVMCofig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) private storage: IWCCStorageManager
    ) {
        const comment = ko.flattenComputed(config.comment);
        this.topicId = comment.pluck('topicId');
        const isForSelectedParticipants = comment.pluck('isForSelectedParticipants', false);
        const commentParticipantsIDs = comment.pluck('threadParticipantIDs', []);

        const userManager = storage.get(CurrentUserManager, { discussionId: settings.discussionId });
        this.user = userManager.pluck('person');

        const participantsManagerAccessor = ko.pureComputed(() => this.getParticipantsManagerAccessor());
        const participantsManager = ko.pureComputed(() => ko.unwrap(participantsManagerAccessor() as PureComputed<TopicParticipantsManager | TinyPeopleListManager | undefined>));
        const allParticipants = participantsManager.pluck('people', []) as PureComputed<Array<PersonTiny | Participant>>;

        this.isLoading = participantsManager.pluck('loading', true);
        this.participants = ko.pureComputed(() => allParticipants().filter(p => commentParticipantsIDs().includes(p.personId() ?? '')));

        this.isActive = ko.pureComputed(() => isForSelectedParticipants() && commentParticipantsIDs().length > 0 && this.participants().length > 0);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isActive,

            'css': {
                'topic__comment__participants': true
            }
        }, this);
    }

    private getParticipantsManagerAccessor() {
        const user = this.user();

        if (user !== undefined) {
            if (user.isModerator()) {
                return this.storage.get(TinyPeopleListManager, {
                    discussionId: settings.discussionId,
                    status: enums.MembershipStatusTypes.Member.value,
                    sortKey: 'LastName'
                });
            } else {
                return this.storage.get(TopicParticipantsManager, {
                    topicId: this.topicId,
                    filter: ''
                });
            }
        }
    }
}